/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Select_Repo_FirstInputs */



/**
* | output |
* | --- |
* | "Select Repository First" |
*
* @param {Spaces_Select_Repo_FirstInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_select_repo_first = /** @type {((inputs?: Spaces_Select_Repo_FirstInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Select_Repo_FirstInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zuerst Repository auswählen")
	return /** @type {LocalizedString} */ ("Select Repository First")
});